import TryItOutIcon from '@/assets/icons/ic_home_try_it_out.svg';
import AIArt from '@/assets/images/home/ai_art.png';
import AIBackground from '@/assets/images/home/ai_background.png';
import AIPhotoEnhan from '@/assets/images/home/ai_photo_enhan.png';
import AISocialPost from '@/assets/images/home/ai_social.png';
import AIWritingAssistant from '@/assets/images/home/ai_writing_assistant.png';
import CommingSoon from '@/assets/images/home/comming_soon.png';
import { analyticsLogEvent, userPropertiesLogEvent } from '@/firebase';
import { eventTracking } from '@/firebase/firebase';
import { ROUTES } from '@/routes/routes';
import React, { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ContentWrapper, HomeTitle, KeyText } from '../../style';
import { ButtonTryFree } from '../Header/style';
import {
  CustomDescription,
  DesProduct,
  FrameProduct,
  GridWrapper,
  ImageProduct,
  ImageWrapper,
  TitleProduct,
  Wrapper,
} from './style';

const Product = () => {
  const navigate = useNavigate();

  const products = useMemo(
    () => [
      {
        id: 1,
        image: AIArt,
        title: 'AI Art Generator',
        description:
          'Transform photos into stunning artistic pieces or create original artwork effortlessly.',
        router: ROUTES.AI_ART_GENERATOR,
      },
      {
        id: 0,
        image: AIBackground,
        title: 'AI Background Changer',
        description:
          'Effortlessly remove backgrounds from your images using our AI-powered Background Remover.',
        router: ROUTES.BACKGROUND_CHANGER,
      },

      {
        id: 2,
        image: AIPhotoEnhan,
        title: 'AI Photo Enhancer',
        description:
          'Enhance sharpness, clarity, colors, and reduce noise to give your images a professional touch.',
        router: ROUTES.AI_PHOTO_ENHANCE,
      },
      {
        id: 3,
        image: AISocialPost,
        title: 'AI Social Post Generator',
        description:
          'Easily generate social media posts with spectacular by AI in one minute.',
        router: ROUTES.SOCIAL_POST_GENERATOR,
      },
      {
        id: 4,
        image: AIWritingAssistant,
        title: 'AI Writing Assistant',
        description:
          'AI Writing Assistant - your creative, fast, and flexible tool to elevate every word.',
        router: ROUTES.AI_WRITING_ASSISTANT_V2,
      },

      {
        id: 5,
        image: CommingSoon,
        title: 'New Features are coming!',
        description:
          'Magical thing by our AI service is about to show up! Can’t wait to suprise you guys.',
        router: '',
      },
    ],
    []
  );

  const goToProduct = useCallback((router: string) => {
    if (router === ROUTES.AI_WRITING_ASSISTANT_V2) {
      analyticsLogEvent(eventTracking.landingPageAiWritingAssistantClick.name);
      userPropertiesLogEvent();
    } else if (router === ROUTES.AI_ART_GENERATOR) {
      analyticsLogEvent(eventTracking.landingPageAiArtGenerateClick.name);
      userPropertiesLogEvent();
    } else if (router === ROUTES.AI_BACKGROUND_REMOVER) {
      analyticsLogEvent(eventTracking.landingPageAiBackgroundRemoverClick.name);
      userPropertiesLogEvent();
    } else if (router === ROUTES.AI_PHOTO_ENHANCE) {
      analyticsLogEvent(eventTracking.landingPageAiPhotoEnhancerClick.name);
      userPropertiesLogEvent();
    }
    // else if (router === ROUTES.AI_WRITING_ASSISTANT) {
    //   analyticsLogEvent(eventTracking.landingPageAiWritingAssistanClick.name);
    //   userPropertiesLogEvent();
    //
    // }
    navigate(router);
  }, []);

  const renderProduct = useCallback((product: any) => {
    return (
      <FrameProduct>
        <ImageWrapper>
          <ImageProduct src={product.image} alt={''} />
        </ImageWrapper>

        <div className="text-wrapper">
          <TitleProduct>{product.title}</TitleProduct>
          <DesProduct>{product.description}</DesProduct>
        </div>
        <ButtonTryFree
          onClick={() => {
            if (product?.id !== 5) {
              goToProduct(product.router);
            }
          }}
          style={{ minWidth: product?.id === 5 ? '125px' : '100px' }}
          disabled={product?.id === 5}
        >
          <p>{product?.id === 5 ? 'Coming Soon' : 'Try Now'}</p>
          <img src={TryItOutIcon} alt="try-now-icon" />
        </ButtonTryFree>
      </FrameProduct>
    );
  }, []);

  return (
    <Wrapper id="product">
      <ContentWrapper>
        <KeyText>PRODUCTS</KeyText>
        <HomeTitle>{'One solution, countless content possibilities'}</HomeTitle>
        <CustomDescription>
          Empower your creativity with Creatorhub: The essential AI toolkit for
          content creators. Elevate your content to new heights for all your
          business needs.
        </CustomDescription>
      </ContentWrapper>

      <GridWrapper>
        {products.map((product: any) => (
          <React.Fragment key={product?.id}>
            {renderProduct(product)}
          </React.Fragment>
        ))}
      </GridWrapper>
    </Wrapper>
  );
};

export default Product;
